export default __webpack_public_path__ + "static/media/vuesax-linear-profile-2user.6509590f.svg";